import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/workshopy" as const,
	[Locale.en]: "/workshops" as const,
} satisfies LocalizedString;

export function getWorkshopsPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
